import React from 'react';
import { Github, Twitter, Linkedin, Mail } from 'lucide-react';
export function Footer() {
  const footerLinks = {
    producto: [{
      label: 'Características',
      href: '#'
    }, {
      label: 'Seguridad',
      href: '#seguridad'
    }, {
      label: 'Integraciones',
      href: '#'
    }, {
      label: 'Precios',
      href: '#'
    }, {
      label: 'API',
      href: '#'
    }],
    empresa: [{
      label: 'Sobre nosotros',
      href: '#'
    }, {
      label: 'Contacto',
      href: '#contacto'
    }],
    legal: [{
      label: 'Privacidad',
      href: '#'
    }, {
      label: 'Términos',
      href: '#'
    }, {
      label: 'Cookies',
      href: '#'
    }, {
      label: 'Cumplimiento',
      href: '#'
    }, {
      label: 'Licencias',
      href: '#'
    }]
  };
  const socialLinks = [{
    icon: Twitter,
    href: '#',
    label: 'Twitter'
  }, {
    icon: Linkedin,
    href: '#',
    label: 'LinkedIn'
  }, {
    icon: Github,
    href: '#',
    label: 'GitHub'
  }, {
    icon: Mail,
    href: '#',
    label: 'Email'
  }];
  return <footer id="contacto" className="bg-navy-900 border-t border-teal-500/10" data-id="element-35">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-36">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-id="element-37">
          {/* Logo & Description */}
          <div className="col-span-2 md:col-span-1" data-id="element-38">
            <a href="#" className="flex items-center space-x-1 mb-4" data-id="element-39">
              <span className="text-2xl font-display font-bold text-white" data-id="element-40">
                tru
              </span>
              <span className="text-2xl font-display font-bold text-teal-500" data-id="element-41">
                id
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-amber-500" data-id="element-42"></span>
            </a>
            <p className="text-sm text-gray-400 mb-6" data-id="element-43">
              Identidad digital segura, privada y bajo tu control.
            </p>
            <div className="flex space-x-4" data-id="element-44">
              {socialLinks.map(social => {
              const Icon = social.icon;
              return <a key={social.label} href={social.href} className="w-9 h-9 bg-navy-800 border border-teal-500/20 rounded-lg flex items-center justify-center hover:border-teal-500 hover:bg-teal-500/10 transition-all" aria-label={social.label} data-id="element-45">
                    <Icon size={18} className="text-gray-400" data-id="element-46" />
                  </a>;
            })}
            </div>
          </div>

          {/* Product Links */}
          <div data-id="element-47">
            <h3 className="font-display font-semibold text-white mb-4" data-id="element-48">
              Producto
            </h3>
            <ul className="space-y-3" data-id="element-49">
              {footerLinks.producto.map(link => <li key={link.label} data-id="element-50">
                  <a href={link.href} className="text-sm text-gray-400 hover:text-teal-500 transition-colors" data-id="element-51">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Company Links */}
          <div data-id="element-52">
            <h3 className="font-display font-semibold text-white mb-4" data-id="element-53">
              Empresa
            </h3>
            <ul className="space-y-3" data-id="element-54">
              {footerLinks.empresa.map(link => <li key={link.label} data-id="element-55">
                  <a href={link.href} className="text-sm text-gray-400 hover:text-teal-500 transition-colors" data-id="element-56">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Legal Links */}
          <div data-id="element-57">
            <h3 className="font-display font-semibold text-white mb-4" data-id="element-58">
              Legal
            </h3>
            <ul className="space-y-3" data-id="element-59">
              {footerLinks.legal.map(link => <li key={link.label} data-id="element-60">
                  <a href={link.href} className="text-sm text-gray-400 hover:text-teal-500 transition-colors" data-id="element-61">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-teal-500/10" data-id="element-62">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0" data-id="element-63">
            <p className="text-sm text-gray-500" data-id="element-64">
              © 2026 truid.org — Todos los derechos reservados
            </p>
            <div className="flex items-center space-x-6 text-sm text-gray-500" data-id="element-65">
              <span data-id="element-66">Hecho con ❤️ para un internet más seguro</span>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}